/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/time';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "ledger": {
        "nested": {
          "LedgerEntry": {
            "nested": {
              "Type": {
                "values": {
                  "INITIAL_BALANCE_CHANGE": 31,
                  "UNDO": 32,
                  "CAPTURE": 1,
                  "REFUND": 2,
                  "ADJUSTMENT": 3,
                  "REDEMPTION": 4,
                  "HOLD": 5,
                  "RELEASE": 6,
                  "UNDO_HOLD": 7,
                  "UNDO_RELEASE": 8,
                  "PAYOUT": 9,
                  "INCENTED_PAYMENT": 10,
                  "BANK_BALANCE_ADJUSTMENT": 11,
                  "MCA_REPAYMENT": 12,
                  "MCA_REPAYMENT_REFUND": 13,
                  "MCA_ADVANCE": 14,
                  "LEGACY_RETURNED_PAYOUT": 15,
                  "SQUARE_PLUS": 16,
                  "RETURNED_SQUARE_PLUS": 17,
                  "LEGACY_ABORTED_PAYOUT": 18,
                  "LEGACY_ACH_TRANSFER": 19,
                  "LEGACY_CORRECTION": 20,
                  "LEGACY_GUARANTEED_PAYMENT": 21,
                  "LEGACY_RETURNED_ACH_ENTRY": 22,
                  "LEGACY_SEED": 23,
                  "LEGACY_TRANSFER": 24,
                  "RETURNED_LEDGER_ENTRY": 25,
                  "FREE_PROCESSING_ADJUSTMENT": 27,
                  "LEGACY_BALANCE_CAPTURE": 28,
                  "LEGACY_BALANCE_REFUND": 29,
                  "SUBSCRIPTION_FEE": 26,
                  "SUBSCRIPTION_FEE_REFUND": 30,
                  "SUBSCRIPTION_FEE_PAID_REFUND": 37,
                  "TAX_ON_FEE": 33,
                  "CAPITAL_FIXED_DEPOSIT": 34,
                  "CAPITAL_FIXED_PAYMENT": 35,
                  "UNDO_TAX_ON_FEE": 36,
                  "OPEN_DISPUTE": 38,
                  "DISPUTE_ADJUSTMENT": 39,
                  "RESOLVED_DISPUTE": 40,
                  "FEE": 41,
                  "UNDO_FEE": 42,
                  "BALANCE_TENDER": 43,
                  "THIRD_PARTY_FEE": 44,
                  "THIRD_PARTY_FEE_REFUND": 47,
                  "MONEY_TRANSFER": 45,
                  "MONEY_TRANSFER_REVERSAL": 46,
                  "ESCHEATMENT": 48,
                  "CAPITAL_PROMOTION_BONUS": 49,
                  "BOOKKEEPER_ADJUSTMENT": 50,
                  "APP_FEE_REVENUE": 51,
                  "APP_FEE_REFUND": 52,
                  "RISK_RESERVE_HOLD": 53,
                  "RISK_RESERVE_RELEASE": 54,
                  "RECOVERY_OFFSET_ADJUSTMENT": 55,
                  "UNLINKED_REFUND": 56,
                  "UNDO_UNLINKED_REFUND": 57,
                  "SQUARE_CARD_TRANSFER": 58,
                  "SFS_SAVINGS_TRANSFER": 59,
                  "INVEST_TRANSFER": 60,
                  "CAPITAL_CREDIT_CARD_TRANSFER": 61,
                  "CAPITAL_LOAN_TRANSFER": 62,
                  "MANUAL_TRANSFER": 63,
                  "BANKING_FOLDERS_TRANSFER": 64,
                  "LOCAL_OFFERS_CASHBACK_TRANSFER": 65,
                  "LOCAL_OFFERS_FEE_TRANSFER": 66,
                  "CASH_FOR_BUSINESS_TRANSFER": 67,
                  "CASH_FOR_BUSINESS_FEE_REFUND": 68,
                  "CASH_FOR_BUSINESS_DISPUTE": 69,
                  "GIFT_CARD_POOL_TRANSFER": 70,
                  "PERCENTAGE_PROCESSING_ENROLLMENT": 71,
                  "PERCENTAGE_PROCESSING_REPAYMENT": 72,
                  "PERCENTAGE_PROCESSING_DEACTIVATION": 73,
                  "PROCESSING_FEE": 74,
                  "PROCESSING_FEE_REFUND": 75,
                  "UNDO_PROCESSING_FEE_REFUND": 76,
                  "GIFT_CARD_LOAD_FEE": 77,
                  "GIFT_CARD_LOAD_FEE_REFUND": 78,
                  "UNDO_GIFT_CARD_LOAD_FEE_REFUND": 79,
                  "DEPOSIT_FEE": 80,
                  "SQUARE_PAYROLL_TRANSFER": 81,
                  "CHECK_ISSUED": 82,
                  "DELIVERY_REIMBURSEMENT": 83
                }
              }
            }
          },
          "SettlementFrequency": {
            "values": {
              "DO_NOT_USE": 0,
              "DAILY": 1,
              "WEEKDAY": 2,
              "WEEKLY": 3
            }
          },
          "PotentialDepositSchedule": {
            "fields": {
              "requestedCutoffAt": {
                "type": "squareup.common.time.LocalTime",
                "id": 1,
                "rule": "optional"
              },
              "depositSchedule": {
                "type": "squareup.ledger.DepositSchedule",
                "id": 2,
                "rule": "optional"
              }
            }
          },
          "DepositSchedule": {
            "fields": {
              "effectiveAt": {
                "type": "squareup.common.time.DateTime",
                "id": 1,
                "rule": "optional"
              },
              "interval": {
                "type": "squareup.ledger.DepositInterval",
                "id": 2,
                "rule": "repeated"
              },
              "timezone": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              },
              "settleIfOptional": {
                "type": "bool",
                "id": 4,
                "rule": "optional"
              }
            }
          },
          "DepositInterval": {
            "fields": {
              "cutoffAt": {
                "type": "squareup.common.time.DayTime",
                "id": 1,
                "rule": "optional"
              },
              "initiateAt": {
                "type": "squareup.common.time.DayTime",
                "id": 2,
                "rule": "optional"
              },
              "sameDaySettlementEnabled": {
                "type": "bool",
                "id": 3,
                "rule": "optional"
              }
            }
          },
          "LedgerEntrySummary": {
            "nested": {
              "Payments": {
                "nested": {
                  "Payment": {
                    "fields": {
                      "paymentToken": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "paymentTakenAt": {
                        "type": "squareup.common.time.DateTime",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.ledger?.nested?.LedgerEntry?.nested?.Type && !$root.nested?.squareup?.nested?.ledger?.nested?.SettlementFrequency && !$root.nested?.squareup?.nested?.ledger?.nested?.PotentialDepositSchedule && !$root.nested?.squareup?.nested?.ledger?.nested?.DepositSchedule && !$root.nested?.squareup?.nested?.ledger?.nested?.DepositInterval && !$root.nested?.squareup?.nested?.ledger?.nested?.LedgerEntrySummary?.nested?.Payments?.nested?.Payment) {
  $root.addJSON(jsonData);
}

/**
 * A ledger entry.
 *
 * SOURCE LedgerEntry @ squareup/ledger/ledger.proto at 23:1
 */
export const LedgerEntry = {};
/**
 * DO NOT CHANGE THE NAMES OF THE ENUMS
 *
 * SOURCE Type @ squareup/ledger/ledger.proto at 25:3
 */
LedgerEntry.Type = $root.lookupEnum('squareup.ledger.LedgerEntry.Type').values;
/**
 * The frequency at which the merchant is to be settled
 *
 * SOURCE SettlementFrequency @ squareup/ledger/ledger.proto at 757:1
 */
export const SettlementFrequency = $root.lookupEnum('squareup.ledger.SettlementFrequency').values;
/**
 * The potential deposit schedule for a cutoff time
 *
 * SOURCE PotentialDepositSchedule @ squareup/ledger/ledger.proto at 1193:1
 */
export const PotentialDepositSchedule = $root.lookupType('squareup.ledger.PotentialDepositSchedule');
fixType(PotentialDepositSchedule);
Builder.createAndAttachToType(PotentialDepositSchedule);
/**
 * Deposit schedule for a week
 *
 * SOURCE DepositSchedule @ squareup/ledger/ledger.proto at 1226:1
 */
export const DepositSchedule = $root.lookupType('squareup.ledger.DepositSchedule');
fixType(DepositSchedule);
Builder.createAndAttachToType(DepositSchedule);
/**
 * Timing information about a settlement deposit
 *
 * SOURCE DepositInterval @ squareup/ledger/ledger.proto at 1255:1
 */
export const DepositInterval = $root.lookupType('squareup.ledger.DepositInterval');
fixType(DepositInterval);
Builder.createAndAttachToType(DepositInterval);
/**
 * Summary message containing useful aggregate information for a given bank settlement entry.
 *
 * SOURCE LedgerEntrySummary @ squareup/ledger/ledger.proto at 1435:1
 */
export const LedgerEntrySummary = {};
/**
 * SOURCE Payments @ squareup/ledger/ledger.proto at 1468:3
 */
LedgerEntrySummary.Payments = {};
/**
 * SOURCE Payment @ squareup/ledger/ledger.proto at 1473:5
 */
LedgerEntrySummary.Payments.Payment = $root.lookupType('squareup.ledger.LedgerEntrySummary.Payments.Payment');
fixType(LedgerEntrySummary.Payments.Payment);
Builder.createAndAttachToType(LedgerEntrySummary.Payments.Payment);